<template>
    <div class="phone-number" v-if="phoneNumber">
        <hp5-call-to-action
          :href="`tel:${callNumber}`"
          icon-name=""
          :screen-reader-only-text="phoneNumber.parenthesisStyleString"
          size="sm"
          target="_self"
          :text="phoneNumber.parenthesisStyleString"
          type="primary"
        >
          <a :data-card-rank="rank" :href="`tel:${callNumber}`" size="sm" target="_self"> {{ phoneNumber.parenthesisStyleString }}</a>
        </hp5-call-to-action>
    </div>
</template>
  
<script setup>

    const props = defineProps({
        callNumber: String,
        phoneNumber: Object,
        rank: Number
    })

  </script>
  
  <style lang="scss" scoped>
    .phone-number {
        margin-right: var(--spacing-sm);
    }
</style>